<!-- 由 suu 创建于 2022-01-18 星期二 -->
<template>
  <div class="result-bmi">
    <div class="bmi-flex">
      <div class="flag" :style="{ left: `${curPercentage}%` }"></div>
      <div class="bmi-item" v-for="(item, index) in bmiList" :key="index"></div>
    </div>
    <div class="bmi-text-list">
      <div class="bmi-text-item" v-for="(item, index) in bmiList" :key="index">
        <div>{{ item.text }}</div>
        <div>{{ item.range }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'result-bmi',

  components: {},

  props: {
    bmi: {}
  },

  data() {
    return {
      curPercentage: 0,
      bmiList: [
        {
          text: '偏瘦',
          range: '＜18.5',
          min: -Infinity,
          max: 18.5
        },
        {
          text: '正常',
          range: '18.5-24',
          min: 18.5,
          max: 24
        },
        {
          text: '偏重',
          range: '24-28',
          min: 24,
          max: 28
        },
        {
          text: '肥胖',
          range: '≥28',
          min: 28,
          max: +Infinity
        }
      ]
    }
  },

  computed: {},

  watch: {
    bmi(val) {
      this.updateBmi(val)
    }
  },

  created() {
    this.updateBmi(this.bmi)
  },

  mounted() {},

  destroyed() {},

  methods: {
    updateBmi(curBmi) {
      curBmi = curBmi < 0 ? 0 : curBmi
      let curPercentage = 0 //箭头指向多少百分比
      let rangePercent = 100 / this.bmiList.length //每个范围占多少百分比
      let curindex = 0 //bmi处于第几个范围
      for (let i = 0; i < this.bmiList.length; i++) {
        let item = this.bmiList[i]
        if (curBmi >= item.min && curBmi < item.max) {
          curindex = i
        }
      }
      if (curindex == 0) {
        let min = curBmi / 1.5
        curPercentage =
          curindex * rangePercent +
          ((curBmi - min) / (this.bmiList[curindex].max - min)) * rangePercent
      } else if (curindex == this.bmiList.length - 1) {
        let max = curBmi * 1.5
        curPercentage =
          curindex * rangePercent +
          ((curBmi - this.bmiList[curindex].min) /
            (max - this.bmiList[curindex].min)) *
            rangePercent
      } else {
        curPercentage =
          curindex * rangePercent +
          ((curBmi - this.bmiList[curindex].min) /
            (this.bmiList[curindex].max - this.bmiList[curindex].min)) *
            rangePercent
      }
      this.curPercentage = curPercentage
      console.log('====================================')
      console.log('curPercentage', curPercentage)
      console.log('====================================')
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 750) * 100vw;
}
.result-bmi {
  width: 100%;
  margin-bottom: vw(44);
  .bmi-flex {
    width: 100%;
    position: relative;
    height: vw(20);
    background-image: linear-gradient(
      90deg,
      #7693ea 0%,
      #b876ae 50%,
      #fa5a73 100%
    );
    border-radius: vw(24);
    display: flex;
    align-items: center;
    margin-bottom: vw(12);
  }
  .flag {
    position: absolute;
    left: 0;
    top: vw(-30);
    height: 0;
    width: 0;
    transform: translate(-50%);
    border-left: vw(10) solid transparent;
    border-right: vw(10) solid transparent;
    border-top: vw(22) solid #000;
    border-bottom: vw(0) solid transparent;
  }
  .bmi-flex .bmi-item {
    flex: 1;
    height: vw(10);
    border-right: vw(2) solid #fff;
    box-sizing: border-box;
  }
  .bmi-flex .bmi-item:last-child {
    border-right: none;
  }
  .bmi-text-list {
    display: flex;
    align-items: center;
    font-size: vw(24);
    color: #202025;
  }
  .bmi-text-item {
    text-align: center;
    flex: 1;
    overflow: hidden;
  }
}
</style>
